import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledMedia = styled.div`
  width: 100%;

  img,
  video,
  iframe {
    max-width: 100%;
    width: 100%;
    border-radius: 6px;
  }

  audio {
    width: 100%;
    min-width: 200px;
    height: 40px;
  }
`;
